import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import ValidatorFormGroup from '../main/validator-form-group';

class FieldSelectTenant extends React.Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        disabled: PropTypes.bool.isRequired,
        supportedTenants: PropTypes.shape({}).isRequired,
    };

    render() {
        function renderOption(value) {
            return (
                <option key={value.tenant_id} value={value.tenant_id}>
                    {value.tenant_name}
                </option>
            );
        }

        const selectedItem = this.props.value;
        const supportedTenants = this.props.supportedTenants;
        return (
            <ValidatorFormGroup label={this.props.label} hideErrorLabel>
                <select
                    disabled={this.props.disabled}
                    className="form-control"
                    name="select_tenant"
                    onChange={this.props.onChange}
                    value={selectedItem}
                >
                    {_.map(
                        supportedTenants && supportedTenants.supported_tenants,
                        renderOption
                    )}
                </select>
            </ValidatorFormGroup>
        );
    }
}

export default FieldSelectTenant;
